import Vue from 'vue';
import Router from 'vue-router';
// import store from "Plugins/vuex";

import index from '../views/index';
import login from '../views/login';
import passwordforgotten from '../views/password-forgotten';
import passwordreset from '../views/password-reset';
import profile from '../views/profile';
import registerexisting from '../views/register-existing';
import registerfull from '../views/register-full';
import registerstart from '../views/register-start';
import notFound from '../views/404';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/passwort-vergessen',
      name: 'passwort-vergessen',
      component: passwordforgotten
    },
    {
      path: '/passwort-zuruecksetzen',
      name: 'passwort-zuruecksetzen',
      component: passwordreset
    },
    {
      path: '/profil',
      name: 'profil',
      component: profile
    },
    {
      path: '/mitgliedsnummer',
      name: 'mitgliedsnummer',
      component: registerexisting
    },
    {
      path: '/registrierung-daten',
      name: 'registrierung-daten',
      component: registerfull,
      props: true
    },
    {
      path: '/registrierung',
      name: 'registrierung',
      component: registerstart
    },
    {
      path: '/registrierung-erfolgreich',
      name: 'registrierung',
      component: registerstart
    },
    {
      path: '/aktivierung',
      name: 'aktivierung',
      component: registerstart
    },
    {
      path: '/404',
      component: notFound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
});

// SBTP
// function updateServedBy(isAllowed) {
//   // add url if allowed and not already set, remove otherwise
//   if (isAllowed) {
//     if (!store.state.servedByURL) {
//       store.commit('updateServedByIFrameSrc', "https://servedby.flashtalking.com/container/5999;117839;4500;iframe/?spotName=Junior_Club_Registrierungen&cachebuster=" + (Math.random() * 1e6));
//     }
//   } else {
//     store.commit('updateServedByIFrameSrc', "");
//   }
// }
//
// router.beforeEach((to, from, next) => {
//   // Handle servedby iframe
//   if (to.path === "/registrierung" && to.hash === "#erfolgreich") {
//     // check in case mounted fires after OneTrust event
//     updateServedBy(window.OnetrustActiveGroups.indexOf(',4,') > -1);
//
//     // Listen for OneTrust consent changes
//     window.OneTrust.OnConsentChanged((e) => {
//       updateServedBy(e.detail.indexOf('4') > -1);
//     });
//   } else {
//     store.commit('updateServedByIFrameSrc', "");
//   }
//   next();
// });

export default router;
